import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import Select from "../../../../components/Select";
import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";

export default function BusinessArea() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [businessAreaList, setBusinessAreaList] = useState([]);

  useEffect(() => {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
        setBusinessAreaList(data);
      });
  }, []);
  
  return (
    <fieldset>
        <legend>{t("Business Area")}</legend>
        <Select
          className="form-select fontsize-legend"
          name="businessAreaId"
          id="businessAreaId"
          onChange={onChange}
          value={searchObject.businessAreaId || ""}
        >
          <option></option>
          {businessAreaList.map((businessArea) => (
            <option className="fontsize-legend" key={businessArea.id} value={businessArea.id}>
              {t(businessArea.description)}
            </option>
          ))}
        </Select>
    </fieldset>
  );
}
